import { useState } from "react";
import VelilerStats from "./components/VelilerStats";
import VelilerTable from "./components/VelilerTable";
import YeniKayitModal from "./components/YeniKayitModal";

export default function VelilerPage() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="p-4 md:p-6 xl:p-8 space-y-6 max-w-[1600px]">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Veliler / Öğrenciler</h2>
          <p className="text-sm text-gray-500 mt-0.5">240+ öğrenci ve veli kayıtlarını yönetin</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <button className="px-3 py-2 text-xs border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 cursor-pointer whitespace-nowrap flex items-center gap-1.5 transition-colors">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-upload-2-line text-xs"></i>
            </div>
            Excel / CSV Yükle
          </button>
          <button className="px-3 py-2 text-xs border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 cursor-pointer whitespace-nowrap flex items-center gap-1.5 transition-colors">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-checkbox-multiple-line text-xs"></i>
            </div>
            Toplu İşlem
          </button>
          <button
            onClick={() => setShowModal(true)}
            className="px-4 py-2 text-xs bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer whitespace-nowrap flex items-center gap-1.5 transition-colors"
          >
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-add-line text-xs"></i>
            </div>
            Yeni Kayıt Ekle
          </button>
        </div>
      </div>

      {/* Stats */}
      <VelilerStats />

      {/* Table */}
      <VelilerTable />

      {/* Modal */}
      {showModal && <YeniKayitModal onClose={() => setShowModal(false)} />}
    </div>
  );
}